import type { FunctionComponent } from 'react';
import React from 'react';
import styles from './Board.less';

export const List: FunctionComponent = ({ children }) => (
  <div className={styles.list}>{children}</div>
);
